module.exports = new __parcel__URL__("task-one-illustration-dark.bf6c9f4d.png").toString();